import { Swiper, SwiperSlide } from 'swiper/react';
import ImgBanner1 from '../../../assets/images/img-banner1.png';
import IconPhone from '../../../assets/icons/ic-phone.svg';
import LogoWhite from '../../../assets/images/logoWhite2.png';
import LogoOffical from '../../../assets/images/logoOffical.png';
import IconFacebook from '../../../assets/icons/ic-facebook.svg';
import IconInstagram from '../../../assets/icons/ic-instagram.svg';
import IconBar from '../../../assets/icons/ic-bars.svg';
import NavigationDesktop from './NavigationDesktop';
import { Pagination } from 'swiper';
import NavigationMobile from './NavigationMobile';
import { useRef, useState } from 'react';
import useClickOutside from 'hook/useClickOutside';
import SelectLanguage from './SelectLanguge';
import Banner from 'components/Banner';
import ImgBannerNew from '../../../assets/images/bg banner.png';
import Tiktok from '../../../assets/icons/tiktok-icon.svg';
import Youtube from '../../../assets/icons/youtube-icon.svg';
import { useTranslation } from 'react-i18next';

const Header = () => {
  //--- Handle sidebar
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenSidebar = () => {
    setIsOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsOpen(false);
  };

  const clickOutsideRef = useRef(null);
  useClickOutside(clickOutsideRef, handleCloseSidebar);
  const { t } = useTranslation('header');
  return (
    <div className="relative" ref={clickOutsideRef}>
      <div className="absolute top-[40px] xl:top-[24px] z-10 w-full">
        <div className="flex justify-between items-center px-4 xl:px-[100px]">
          <div className="hidden xl:flex items-center gap-x-2">
            <img src={IconPhone} alt="phone" />
            <span className="text-white">090 796 85 52</span>
          </div>

          <img src={LogoWhite} alt="logo white" className="w-[72px] xl:w-[120px]" />
          <div className="flex items-center gap-x-4">
            <div className="hidden xl:flex items-center gap-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=100083419447159"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IconFacebook} alt="facebook" width={30} height={30} />
              </a>
              <a
                href="https://www.instagram.com/tanlocrestaurant/?igshid=OGQ5ZDc2ODk2ZA%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IconInstagram} alt="instagram" width={30} height={30} />
              </a>
              <a
                href="https://www.tiktok.com/@tanlocseafood_restaurant"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Tiktok} alt="Tiktok" width={30} height={30} />
              </a>
              <a
                href="https://www.youtube.com/@TanLocSeafood_Restaurant/featured"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Youtube} alt="Youtube" width={30} height={30} />
              </a>
            </div>
            <div>
              <SelectLanguage />
            </div>
          </div>

          <div className="block xl:hidden" onClick={() => handleOpenSidebar()}>
            <img src={IconBar} alt="bar" />
          </div>
        </div>

        <NavigationDesktop />
      </div>

      <NavigationMobile isOpen={isOpen} handleCloseSidebar={() => handleCloseSidebar()} />

      <Swiper slidesPerView={1} pagination={true} modules={[Pagination]}>
        <SwiperSlide>
          <Banner imgSrc={ImgBannerNew} title={t('banner.title')} />
        </SwiperSlide>
        <SwiperSlide>
          <Banner imgSrc={ImgBannerNew} title={t('banner.title')} />
        </SwiperSlide>
        <SwiperSlide>
          <Banner imgSrc={ImgBannerNew} title={t('banner.title')} />
        </SwiperSlide>
        <SwiperSlide>
          <Banner imgSrc={ImgBannerNew} title={t('banner.title')} />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Header;
